import type { CheckboxVariantProps } from './Checkbox.variants';

type Size = NonNullable<CheckboxVariantProps['size']>;
type Variant = NonNullable<CheckboxVariantProps['variant']>;

/** Check-glyph size per checkbox size (Figma: 12/14/16px inside 16/20/24 boxes). */
export const CHECK_SIZE_FOR: Record<Size, number> = { s: 12, m: 14, l: 16 };

/** Bolder-than-default stroke to match the Figma checkmark weight. */
export const CHECK_STROKE = 3;

/**
 * Resolved check color per (variant, dark-mode). Returned as a hex string
 * because `lucide-react-native` reads `color` as a prop, not a className.
 *
 *   - primary → white in both modes (fill is the fixed `primary-500` #8e51ff).
 *   - default → secondary-600 (#525252) light / secondary-400 (#a1a1a1) dark —
 *     the palindromic auto-inverted value, keeping contrast on the near-black
 *     `secondary-50` box in dark mode.
 */
export function resolveCheckColor(variant: Variant, isDark: boolean): string {
  if (variant === 'primary') return '#ffffff';
  return isDark ? '#a1a1a1' : '#525252';
}
